import { createFileRoute } from '@tanstack/react-router';
import { App } from '@/app/pages/home/App.page';

export const Route = createFileRoute('/')({
    component: App,
});

